window.addEventListener("DOMContentLoaded", () => {
    let filter = document.querySelector(".filter-category-filter__buttons");
    let projectTypeFilter = document.querySelector(".project-type-filter__buttons");
    let loadMoreWrapper = document.getElementById("load-more-projects");
    let container = document.querySelector(".post-grid");
    let urlParams = new URLSearchParams(window.location.search);

    if (filter) {
        filter.addEventListener("click", handleFilterClick);
    }

    if (projectTypeFilter) {
        projectTypeFilter.addEventListener("click", handleProjectTypeFilterClick);
    }

    if (loadMoreWrapper) {
        loadMoreWrapper.addEventListener("click", handleArchiveLoadMore);
    }

    syncSelectedButton(filter, "data-filter", "type");
    syncSelectedButton(projectTypeFilter, "data-project-type", "for");

    function syncSelectedButton(group, dataAttr, paramName) {
        if (!group) {
            return;
        }

        let currentValue = urlParams.get(paramName) || "all";
        let selectedButton = group.querySelector(`button[${dataAttr}="${currentValue}"]`);

        group.querySelector(".selected")?.classList.remove("selected");

        if (selectedButton) {
            selectedButton.classList.add("selected");
            return;
        }

        let allButton = group.querySelector(`button[${dataAttr}="all"]`);
        if (allButton) {
            allButton.classList.add("selected");
        }
    }

    // When user clicks on filter buttons
    function handleFilterClick(e) {
        let element = e.target.closest("button[data-filter]");

        if (!element || !filter.contains(element)) {
            return; // didn't click on a button
        }

        if (element.classList.contains("selected")) {
            return; // button is already selected
        }

        if (element.disabled) {
            return;
        }

        filter.querySelector(".selected").classList.remove("selected");
        element.classList.add("selected");

        updateUrlState("type", element.dataset.filter);

        fetchProjects()
            .then((response) => updateFilterButtonStates(response))
            .then((response) => updateTabbedContent(response))
            .then((response) => updateFAQs(response));
    }

    function handleProjectTypeFilterClick(e) {
        let element = e.target.closest("button[data-project-type]");

        if (!element || !projectTypeFilter.contains(element)) {
            return;
        }

        if (element.classList.contains("selected")) {
            return;
        }

        if (element.disabled) {
            return;
        }

        projectTypeFilter.querySelector(".selected")?.classList.remove("selected");
        element.classList.add("selected");

        updateUrlState("for", element.dataset.projectType);

        fetchProjects()
            .then((response) => updateFilterButtonStates(response))
            .then((response) => updateTabbedContent(response))
            .then((response) => updateFAQs(response));
    }

    function updateUrlState(paramName, value) {
        if (value === "all") {
            urlParams.delete(paramName);
        } else {
            urlParams.set(paramName, value);
        }

        const nextUrl = `${window.location.pathname}${urlParams.toString() ? `?${urlParams.toString()}` : ""}`;
        window.history.replaceState({}, "", nextUrl);
    }

    // When user clicks load more button
    function handleArchiveLoadMore(e) {
        e.preventDefault();

        if (e.target.tagName != "BUTTON") {
            return;
        }

        let page = e.target.hasAttribute("data-page");
        let type = e.target.hasAttribute("data-type");

        if (page && type) {
            fetchProjects(
                e.target.getAttribute("data-page"),
                e.target.getAttribute("data-type"),
            );
        } else {
            console.error("Missing Attribute");
        }
    }

    async function fetchProjects(page = 1, type = "projects") {
        let APIurl = `${restApi.url}custom/v1/projects/?page=${page}&type=${type}`;

        let searchTerm = filter ? filter.querySelector("button.selected[data-filter]") : null;
        let projectTypeTerm = projectTypeFilter ? projectTypeFilter.querySelector("button.selected[data-project-type]") : null;

        if (searchTerm) {
            APIurl = APIurl + "&term=" + searchTerm.dataset.filter;
        }

        if (projectTypeTerm) {
            APIurl = APIurl + "&project_type=" + projectTypeTerm.dataset.projectType;
        }

        try {
            const response = await fetch(APIurl, {
                method: "GET",
                headers: { "X-WP-Nonce": restApi.nonce },
            });

            if (!response.ok) {
                throw new Error("Failed fetching more posts");
            }

            const data = await response.json();

            let button = loadMoreWrapper.querySelector("button");

            // update button
            button.dataset.page = data.page;

            if (data.is_last_page || data.max_pages <= 1 || data.page > data.max_pages) {
                loadMoreWrapper.style.display = "none";
            } else {
                loadMoreWrapper.style.display = "flex";
            }

            // https://developer.chrome.com/docs/web-platform/view-transitions
            if (!document.startViewTransition) {
                insertContent(page, data.body);
            } else {
                document.startViewTransition(() =>
                    insertContent(page, data.body),
                );
            }

            return data;
        } catch (error) {
            console.error("Error:", error);
        }
    }

    // Add the cards in the grid
    function insertContent(page, content) {
        if (page > 1) {
            return container.insertAdjacentHTML("beforeend", content);
        }

        return (container.innerHTML = content);
    }

    // Updates disabled/enabled states for both filter button groups.
    function updateFilterButtonStates(data) {
        if (!data) {
            return data;
        }

        updateButtonGroupState(
            projectTypeFilter,
            "data-project-type",
            data.available_project_types,
            "for",
        );
        updateButtonGroupState(
            filter,
            "data-filter",
            data.available_categories,
            "type",
        );

        return data;
    }

    function updateButtonGroupState(group, dataAttr, availableValues, paramName) {
        if (!group || !Array.isArray(availableValues)) {
            return;
        }

        const availableSet = new Set(availableValues);
        const buttons = group.querySelectorAll(`button[${dataAttr}]`);

        buttons.forEach((button) => {
            const value = button.getAttribute(dataAttr);
            if (value === "all") {
                button.disabled = false;
                return;
            }

            button.disabled = !availableSet.has(value);
        });

        const selectedButton = group.querySelector(".selected");
        if (!selectedButton || selectedButton.disabled) {
            selectedButton?.classList.remove("selected");

            const allButton = group.querySelector(`button[${dataAttr}="all"]`);
            if (allButton) {
                allButton.classList.add("selected");
            }
            updateUrlState(paramName, "all");
        }
    }

    // Replaces the tabbed content block under the Project cards.
    function updateTabbedContent(data) {
        if (!data || !data.hasOwnProperty("tabbed_content_html")) {
            return data;
        }

        let tabbedContentWrapper = document.getElementById(
            "dynamic-content-tabs",
        );

        if (tabbedContentWrapper) {
            tabbedContentWrapper.innerHTML = data.tabbed_content_html;
            document.dispatchEvent(
                new CustomEvent("contentTabs:init", {
                    detail: { scope: tabbedContentWrapper },
                }),
            );
        }

        return data;
    }

    // Replaces the FAQ block under the tabbed content.
    function updateFAQs(data) {
        if (!data || !data.hasOwnProperty("faqs_html")) {
            return data;
        }

        let faqWrapper = document.getElementById("dynamic-faqs");

        if (faqWrapper) {
            faqWrapper.innerHTML = data.faqs_html;
        }

        return data;
    }
});
